import styled from 'styled-components'
import { Box, Typography } from 'src/components'
import ImageInitial from 'src/assets/404Error/ImageInitial.avif'
import { motion } from 'framer-motion'

export const Over = styled(Box)`
    height: auto;
    flex-direction: column;
    display: flex;
    width: 100%;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        flex-direction: row;
        height: 100vh;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        flex-direction: row;
    }
`
export const OverContainer = styled(Box)`
    height: 94%;
    background: url(${ImageInitial}) no-repeat center/cover;
    position: relative;
    display: flex;
    width: 100%;
    flex-direction: column;
    border-radius: 15px;
    justify-content: center;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 94%;
        flex-direction: row;
        height: 100vh;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 96%;
    }
`
export const OverIcons = styled(Box)`
    width: 100%;
    height: 6%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 6%;
        height: 100%;
        flex-direction: column;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 4%;
    }
`
export const Spacing = styled(Box)`
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        height: 45%;
        flex-direction: column;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`
export const Text = styled(Box)`
    z-index: 20;
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 1280px;
        flex-direction: row;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 1280px;
    }
`
export const OverSpan = styled.span`
    position: absolute;
    background-size: cover;
    background-position: center center;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0.8;
    background-image: linear-gradient(
        0deg,
        rgba(0, 0, 0, 0.7),
        rgba(0, 0, 0, 0.7)
    );
`
export const SectionImage = styled(Box)`
    width: 100%;

    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 40%;
        display: flex;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`
export const Image = styled.img`
    width: 100%;
    object-fit: contain;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`
export const SectionTypography = styled(Box)`
    width: 100%;
    display: flex;
    align-items: center;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 56%;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`
export const Error = styled(Box)`
    width: 490px;
    height: 333px;
    display: flex;
    flex-direction: column;
    align-items: center;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        align-items: start;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`
export const ErrorTypography = styled(Typography)`
    font-family: inherit;
    font-style: normal;
    line-height: 106.7%;
    color: ${({ theme }) => theme.colors.white};
`
export const Content = styled(Typography)`
    font-family: inherit;
    font-style: normal;
    font-weight: 400;
    font-size: 19.6px;
    line-height: 106.7%;
    text-align: center;
    color: ${({ theme }) => theme.colors.white};
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        text-align: start;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`
export const ContentButton = styled(motion(Box))`
    width: 200px;
    height: 40px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
`
